import Cookies from 'js-cookie'

// TOKEN
const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// UserInfo
const UserInfo = 'userInfo'

export function getUserInfoCookie() {
  let string = Cookies.get(UserInfo);
  if (string) {
    return JSON.parse(string);
  }
  return {}
}

export function setUserInfoCookie(userInfo) {
  return Cookies.set(UserInfo, userInfo)
}

export function removeUserInfoCookie() {
  return Cookies.remove(UserInfo)
}